import * as React from 'react';
import styled, {
  createGlobalStyle,
} from 'styled-components';
import CloseIcon from '@material-ui/icons/Close';
import { ClickAwayListener } from '@material-ui/core';

import { useReactToPrint } from 'react-to-print';
import { ButtonModalClose } from '../atoms';
import { ButtonWithLoader } from './index';
import FormsReport from '../pages/Reports/FormsReport';

const ModalFullScreen = ({
  children,
  title,
  onClose,
  className = '',
  printRef,
}: Props) => {
  const containerRef = React.useRef(null);
  return (
    <ModalContainer ref={containerRef} className={className}>
      <GlobalStyles />
      <ModalContent>
        <MobileClose onTouchStart={onClose}>
          <CloseWrapper>
            <CloseIcon />
          </CloseWrapper>
        </MobileClose>
        <StyledButtonModalClose onClick={onClose} />
        <StyledTitle>{title}</StyledTitle>
        <ModalContentInner>
          <div>{children}</div>
        </ModalContentInner>
      </ModalContent>
    </ModalContainer>
  );
};

const GlobalStyles = createGlobalStyle`
  body {
    max-height: 100vh;
    overflow: hidden;
    padding-right: 17px;
    
    @media print {
      table[role="table"] {
        display: none;
      }
    }
  }
`;

const MobileClose = styled.button`
 width: 32px;
 height: 32px;
 border-radius:50%;
 z-index: 300;
 position: absolute;
 right:32px;
 top:32px;
 background-color:#fff;
 @media only screen and (min-width: 840px) {
   display:none;
 }
`;

const CloseWrapper = styled.div`  ;
zoom: 1.2;
position: relative;
left: -5px;
top: -2px;
`;
const ModalContainer = styled.div`
  position: fixed;
  z-index: var(--modalZIndex);
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  padding: 40px 20px;
  overflow-x: hidden;
  overflow: auto;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background-color: rgba(19, 23, 32, 0.45);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  ${({ className }) =>
    className === 'over' && 'overflow: visible;'}
`;

const ModalContent = styled.div`
  background-color: var(--neutral-0);
  width: 100%;
  min-width: 280px;
  max-width: 100%;
  height: 100%;
  padding: var(--space-8) var(--space-8) var(--space-6);
  border-radius: var(--radius-lg);
  border: 1px solid var(--neutral-200);
  box-shadow: var(--shadow-lg);
  position: absolute;
  overflow: auto;

  @media print {
    box-shadow: none;
    border: 0;
  }
`;

const ModalContentInner = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
`;

const StyledTitle = styled.div`
  width: 90%;
  font-size: var(--fs-2xl);
  font-weight: var(--fw-semibold);
  color: var(--neutral-900);
  line-height: var(--lh-snug);
  text-align: center;
  margin: 0 auto var(--space-6);
  letter-spacing: -0.005em;
`;

const StyledButtonModalClose = styled(ButtonModalClose)`
  top: 20px;
  right: 20px;

  @media print {
    display: none;
  }
`;

interface Props {
  children: React.ReactNode | React.ReactNodeArray;
  title?: string;
  onClose: () => void;
  className?: string;
}

export default ModalFullScreen;
